import React, { useContext } from 'react'
import { QuizContext } from '../contexts/quizContext'

export default function QuizChoice({ answerOption }) {
  const { quiz, dispatch } = useContext(QuizContext)

  const handleAnswerSelect = (e) => {
    if ( !quiz.submitted ) {
      dispatch({type: 'SET_ANSWER', answer: e.target.value })
    }
  }

  return (
    <div className="choice col-sm-12 col-md-6">
      <label className={ (quiz.chosenAnswer === answerOption) ? `selected-choice` : `` }>
      <div className={ (quiz.chosenAnswer === answerOption) ? `iradio_flat-green checked` : `iradio_flat-green` }>
          <input type="radio" name="choice" value={answerOption} required="" onClick={handleAnswerSelect} />
          <ins className="iCheck-helper"></ins>
      </div>
      <span>{answerOption}</span>
      </label>
  </div>
  )
}


